import { addMinutes } from 'date-fns';

const SECONDS_PER_DAY = 86400;
const SECONDS_PER_HOUR = 3600;

/**
 * Converts seconds to days and hours
 * @param timeInSeconds
 * @returns {{hours: number, days: number}}
 */
const convertSecondsToDaysHours = (timeInSeconds: number) => {
  let daysHours;
  const days = Math.floor(timeInSeconds / SECONDS_PER_DAY);
  const left = timeInSeconds % SECONDS_PER_DAY;
  const hours = left / SECONDS_PER_HOUR;
  if (days > 0 || hours > 0) {
    daysHours = {
      days,
      hours,
    };
  }
  return daysHours;
};

/**
 * Converts a numerical string value to a number in seconds
 * @param value
 * @param conversionValue
 * @returns {number}
 */
const convertToSeconds = (value: string, conversionValue: number) => {
  let totalSeconds = 0;
  const valueAsNumber = parseInt(value, 10);
  if (!Number.isNaN(valueAsNumber)) {
    totalSeconds = valueAsNumber * conversionValue;
  }

  return totalSeconds;
};

const dateToZuluTime = (date: Date) => {
  date = date == null ? new Date() : date;
  const offsetMin = -1 * date.getTimezoneOffset();
  return addMinutes(date, offsetMin);
};

const dateFromZuluTime = (date: Date) => {
  date = date == null ? new Date() : date;
  /*
  Ensure that current time is using the same time format as date.
  Time zone needs to be the same when getting offset.
  */
  const currTime = new Date(date);
  return addMinutes(date, currTime.getTimezoneOffset());
};

export {
  convertSecondsToDaysHours,
  convertToSeconds,
  dateFromZuluTime,
  dateToZuluTime,
  SECONDS_PER_DAY,
  SECONDS_PER_HOUR,
};
